import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  CardBody,
  CardContainer,
  CardHeader,
} from "../../../components/DashboardCard/DashboardCard";
import {
  NavTab,
  NavTabPanel,
  NavTabs,
} from "../../../components/NavTabs/NavTabs";
import { ConfigNavTabs } from "../Program/ProgramConfig";
import EntrySearchTab from "../Search/EntrySearchTab";
import PauseSlide from "./PauseSlide";
import BrowserHeader from "../../../components/BrowserHeader/BrowserHeader";
import Features from "./Features";
import AdminDropdownConfig from "../DynamicDropdowns/AdminDropdownConfig";

const Settings = (props: { tab: string }) => {
  const tabs = ["Features", "pause-slide", "Dropdowns"];
  const tabNames = ["Features", "Pause Slide", "Dropdowns"];

  const defaultTab = tabs.indexOf(
    props.tab || "Features" || "pause-slide" || "Dropdowns",
  );
  const [tabIndex, setTabIndex] = useState(defaultTab);

  useEffect(() => {
    setTabIndex(defaultTab);
  }, [defaultTab]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [tabIndex]);

  return (
    <CardContainer>
      <BrowserHeader title={`Settings: ${tabNames[tabIndex]}`} />
      <CardHeader>
        <h2 className="card-title">Settings</h2>
      </CardHeader>
      <NavTabs
        selectedIndex={tabIndex}
        onSelect={(index) => setTabIndex(index)}
      >
        <ConfigNavTabs>
          <NavTab>
            <Link className="no-underline" to="/settings/features">
              Features
            </Link>
          </NavTab>
          <NavTab>
            <Link className="no-underline" to="/settings/pause-slide">
              Pause Slide
            </Link>
          </NavTab>
          <NavTab>
            <Link className="no-underline" to="/settings/dropdowns">
              Dropdowns
            </Link>
          </NavTab>
        </ConfigNavTabs>
        <NavTabPanel>
          <CardBody>
            <Features />
          </CardBody>
        </NavTabPanel>
        <NavTabPanel>
          <CardBody>
            <PauseSlide />
          </CardBody>
        </NavTabPanel>
        <NavTabPanel>
          <CardBody>
            <AdminDropdownConfig />
          </CardBody>
        </NavTabPanel>
      </NavTabs>
    </CardContainer>
  );
};

export default Settings;

export interface SettingsModel {
  id?: number;
  paymentThreshold?: number;
  pauseSlidePath?: string;
  isDemo: boolean;
  countryIso: string;
  featureFlags: { [key: string]: boolean };
}
